export type TerrainShortSlopeType = 'beginner' | 'intermediate' | 'advanced' | 'expert';
export const terrainShortSlopeTypes: Array<TerrainShortSlopeType> = ['beginner', 'intermediate', 'advanced', 'expert'];
